export default "__VITE_ASSET__BTCOrZkQ__"